import { put, takeLatest, call, delay, takeEvery } from "redux-saga/effects";
import deductionService from "../../axios/services/deductionService";
import { closeTab, createTab } from "../../utils/helpers/tabHelper";
import { authActionTypes } from "../actions/authActions";
import { deductionActions, deductionTypes } from "../actions/deductionActions";

const initialState = {
  activeTabKey: 0,
  tabs: [],
  items: [],
  tableConfig: {
    isLoading: false,
    totalData: 0,
    limit: 10,
    sort: "createdAt|desc",
    page: 1
  }
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case deductionTypes.LOAD_REQUESTED: {
      return {
        ...state,
        tableConfig: {
          ...state.tableConfig,
          isLoading: true,
        }
      }
    }
    case deductionTypes.LOADED: {
      return {
        ...state,
        items: action.payload.data.deductions,
        tableConfig: {
          ...state.tableConfig,
          totalData: action.payload.data.count,
          isLoading: false,
        }
      };
    }
    case deductionTypes.SET_TABLE_CONFIG: {
      return {
        ...state,
        tableConfig: {
          ...state.tableConfig,
          [action.key]: action.value
        }
      };
    }
    case deductionTypes.SET_TABLE_CONFIG_FILTER: {
      return {
        ...state,
        tableConfig: {
          ...state.tableConfig,
          filter: {
            ...state.tableConfig.filter,
            [action.key]: action.value
          },
          page: 1
        }
      };
    }
    case deductionTypes.CHANGE_TAB:
      return {
        ...state,
        activeTabKey: action.key,
      }
    case deductionTypes.CLOSE_TAB: {
      const { newTabs, nextKey } = closeTab(state.tabs, action.key, state.activeTabKey);
      return {
        ...state,
        tabs: newTabs,
        activeTabKey: nextKey
      }
    }
    case deductionTypes.CREATE_TAB: {
      const newTabs = createTab(state.tabs, action.key, action.title);
      return {
        ...state,
        tabs: newTabs,
        activeTabKey: action.key
      }
    }
    case deductionTypes.GET_DETAIL_REQUESTED: {
      const clonedTabs = [...state.tabs];
      if (clonedTabs[action.index]) clonedTabs[action.index].loading = true;
      return {
        ...state,
        tabs: clonedTabs
      };
    }
    case deductionTypes.GET_DETAIL_LOADED: {
      const clonedTabs = [...state.tabs];
      if (clonedTabs[action.index]) {
        clonedTabs[action.index].loading = false;
        clonedTabs[action.index].item = action.payload.data.deduction;
      }
      return {
        ...state,
        tabs: clonedTabs
      };
    }
    case authActionTypes.LOGOUT: {
      return initialState;
    }
    default:
      return state;
  }
};

export function* saga() {
  yield takeLatest(deductionTypes.LOAD_REQUESTED, function* loadData({ tableConfig }) {
    yield delay(300);
    try {
      const { data } = yield call(deductionService.list, {
        page: tableConfig.page,
        limit: tableConfig.limit,
        sort: tableConfig.sort
      });
      yield put(deductionActions.loaded(data));
    } catch (error) {
      // console.log('error reached', error);
    }
  });

  yield takeEvery(deductionTypes.GET_DETAIL_REQUESTED, function* getDetail({ id, index }) {
    yield delay(300);
    try {
      const { data } = yield call(deductionService.detail, id);
      yield put(deductionActions.getDetailLoaded(data, index));
    } catch (error) {
      // console.log('error reached', error);
    }
  });
}
